import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgThumbsUpIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m10.7 15.42-1.71-.03c-1.87 0-3.08-1.27-3.08-3.23h1.25c0 1.79 1.29 1.98 1.84 1.98l1.71.03c.48 0 1.03-.01 1.55-.03.5-.01.98-.02 1.38-.02.5 0 1.09-.39 1.09-.9 0-.25-.05-.7-.38-.89a.816.816 0 0 1-.41-.78c.02-.3.22-.57.5-.68.2-.08.33-.21.33-.56 0-.12 0-.38-.51-.56a.794.794 0 0 1-.54-.73c-.01-.33.17-.63.48-.77.48-.22.54-.52.54-.75 0-.32 0-.99-1.98-.99l-2.08.01c-.28.01-.6-.12-.81-.33-.22-.22-.34-.5-.34-.81l-.01-3.43c0-.34-.28-.62-.63-.62-.3 0-.56.23-.62.56-.64 3.26-1.86 4.99-3.62 5.15v8.05H-.06V8.71c0-1.33.77-2.91 4.44-2.91 1.52 0 2.29-2.26 2.66-4.15C7.22.73 7.98.08 8.89.08c1.03 0 1.87.84 1.88 1.87l.01 3.33 1.98-.01c2.67 0 3.23 1.22 3.23 2.24 0 .58-.21 1.08-.62 1.46.42.34.65.81.65 1.36 0 .57-.19 1.04-.55 1.37.32.39.5.93.5 1.54 0 1.28-1.21 2.15-2.34 2.15-.39 0-.86.01-1.35.02-.52 0-1.08.01-1.58.01Zm-9.5-1.59h2.21V7.09C1.2 7.32 1.2 8.34 1.2 8.71v5.12Z",
    fill: "currentColor"
  }));
}

export { SvgThumbsUpIcon as default };
